import { DeleteAccountTypeEnum } from 'api/enums';
import { Form, Formik } from 'formik';
import { FormikFloatingInput } from 'library/forms';
import { DocumentTitle } from 'library/head';
import ActionButton from 'modules/auth/components/ui/ActionButton';
import { useMemo, useState } from 'react';
import { toast } from 'react-toastify';

interface IDeleteAccountForm {
    emailOrUsername: string;
}

interface IDeleteAccountProps {
    type?: DeleteAccountTypeEnum;
}

const Page = (props: IDeleteAccountProps) => {
    const { type } = props;

    const [errorMessage, setErrorMessage] = useState<string>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSubmit = async (values: IDeleteAccountForm, { resetForm }: any) => {
        if (!values.emailOrUsername) {
            setErrorMessage('Invalid email or username.');
            return;
        }

        setIsLoading(true);

        try {
            await new Promise((resolve) => setTimeout(resolve, 2000));

            toast.success('Request sent successfully.');

            resetForm();

            setIsLoading(false);
        } catch (err: any) {
            setErrorMessage(err.response.data.message);

            setIsLoading(false);
        }
    };

    const imageBackgroundStyles = useMemo(() => {
        return {
            backgroundImage: 'url("/images/login-image-left.svg"), url("/images/login-image-right.svg")',
            backgroundPosition: '0 0, 100% 100%',
            backgroundSize: '36%, 28%',
        };
    }, []);

    return (
        <>
            <DocumentTitle>Delete Account</DocumentTitle>

            <div className="relative flex min-h-screen bg-primary bg-no-repeat" style={imageBackgroundStyles}>
                <div className="relative container mx-auto px-6 z-[1]">
                    <div className="flex h-full py-16 gap-4">
                        <div className="flex-1 hidden lg:flex flex-col items-start h-full">
                            {type === DeleteAccountTypeEnum.PROGRESS_CENTER ? (
                                <img className={'h-10'} src={'/logos/logo-full.svg'} alt="" />
                            ) : (
                                <div className="text-card-color text-3xl font-semibold">SiteWalk Capture</div>
                            )}

                            {type === DeleteAccountTypeEnum.PROGRESS_CENTER && (
                                <div className="mt-auto">
                                    <div className={'text-white text-sm mt-12'}>
                                        Copyright © {new Date().getFullYear()} TimeLapse ME · Privacy & terms
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="flex-1 self-center w-full">
                            <div className="bg-white p-8 sm:p-[52px] rounded-lg ">
                                <div>
                                    <h2 className="text-10"> {'Delete your account'}</h2>
                                    <div className="text-grayscale-500 max-w-lg mt-3">
                                        {'Enter your email or username to request account deletion.'}
                                    </div>
                                    {/* <div className="text-grayscale-500 max-w-sm mt-3"></div> */}
                                    <div className="mt-8">
                                        <Formik
                                            initialValues={{
                                                emailOrUsername: '',
                                                password: '',
                                                rememberMe: false,
                                            }}
                                            onSubmit={handleSubmit}
                                        >
                                            <Form>
                                                <div>
                                                    <FormikFloatingInput
                                                        name="emailOrUsername"
                                                        label="Email or Username"
                                                        invalid={Boolean(errorMessage)}
                                                        onKeyUp={() => setErrorMessage(null)}
                                                    />
                                                </div>

                                                {errorMessage && (
                                                    <div className="form-error-message text-sm">{errorMessage}</div>
                                                )}

                                                <div className="mt-8">
                                                    <ActionButton isLoading={isLoading} loadingText="Submitting">
                                                        Submit
                                                    </ActionButton>
                                                </div>
                                            </Form>
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
